class ProductForm extends HTMLElement {
    constructor() {
        super();

        this.selectVariant = this.querySelector('select[name="id"]');
    }

    connectedCallback() {
        console.log('product', JSON.parse(this.dataset.product));

        this.selectVariant.addEventListener('change', (e) => {
            this.querySelector('form input[name="id"]').value = e.currentTarget.value;

            const select = e.currentTarget;
            const selectedOption = select.options[select.selectedIndex];
            const variantPrice = selectedOption.dataset.price;
            const variantComparePrice = selectedOption.dataset.comparePrice || false;

            const priceElem = this.parentNode.querySelector('dl[data-price]');
            const priceElemRegular = priceElem.querySelector('[data-regular-price]');
            const priceElemSale = priceElem.querySelector('[data-sale-price]');

            priceElemRegular.textContent = variantPrice;
            priceElemSale.textContent = variantComparePrice ? variantComparePrice : '';
            priceElem.classList[variantComparePrice ? 'add' : 'remove']('price--on-sale');
        });
    }
}

customElements.get('product-form') || customElements.define('product-form', ProductForm);